// extracted by mini-css-extract-plugin
export var container = "_4m-0";
export var disabled = "_4m-4";
export var fullWidth = "_4m-3";
export var lined = "_4m-1";
export var selected = "_4m-5";
export var tab = "_4m-2";